export const CREDIT_RATING_DESCRIPTIONS = [
  {
    key: 'agency',
    displayValue: 'Agency',
  },
  {
    key: 'rating',
    displayValue: 'Rating',
  },
  {
    key: 'description',
    displayValue: 'Description',
  },
];
